import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PartNumber} from "@models/partNumber.model";
import {TableConfig} from "@app/shared/util/table-config.utils";
import {Log} from "ng2-logger";
import {PartNumberStatus} from "@models/enums/part-number-status.enum";
import {AuthenticationService} from "@app/authentication/services/authentication.service";

@Component({
    selector: 'app-partnumber-table',
    templateUrl: './partnumber-table.component.html',
    styleUrls: ['./partnumber-table.component.scss']
})
export class PartNumberTableComponent {
    _logger = Log.create(PartNumberTableComponent.name);

    @Input() partNumbers: PartNumber[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = true;
    @Input() readOnly = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();
    @Output() duplicateRow = new EventEmitter<any>();


    onPageChange(tableConfig: TableConfig) {
        this._logger.info('onPageChange::', tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info('onSortChange::', tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info('onFilterChange::', tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this._logger.info('onRowClick::', clickedItem);
        this.rowClick.emit(clickedItem);
    }

    onDuplicate(duplicate) {
        this._logger.info('onDuplicate::', duplicate);
        this.duplicateRow.emit(duplicate);
    }

    isConfigured(record) {
        return record.status === PartNumberStatus.CONFIGURED;
    }
}
